(function () { var require = undefined; var define = undefined; (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

/**
 * Creates a cookie
 *
 * @param name
 * @param value
 * @param days
 */
function create(name, value, days) {
  var expires;

  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toGMTString();
  } else {
    expires = '';
  }

  document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + expires + '; path=/';
}
/**
 * Reads a cookie
 *
 * @param name
 * @returns {*}
 */


function read(name) {
  var nameEQ = encodeURIComponent(name) + '=';
  var ca = document.cookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }

    if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
  }

  return null;
}
/**
 * Erases a cookie
 *
 * @param name
 */


function erase(name) {
  create(name, '', -1);
}

module.exports = {
  read: read,
  create: create,
  erase: erase
};

},{}],2:[function(require,module,exports){
"use strict";

var cookie = require('./_cookie.js');

function getUrlValue(key) {
  var regex = new RegExp(key + '=([^&]+)');
  var matches = regex.exec(window.location.search);

  if (matches && matches.length > 0) {
    return matches[1];
  }

  return '';
} // set mc_cid, mc_eid & mc_tc cookies if url params are set


['mc_cid', 'mc_eid', 'mc_tc'].forEach(function (name) {
  var value = getUrlValue(name);

  if (value !== '') {
    cookie.create(name, value, 14);
  }
}); // store landing site in mc_landing_site cookie, if not set

if (!cookie.read('mc_landing_site')) {
  cookie.create('mc_landing_site', window.location.href, 7);
}

},{"./_cookie.js":1}]},{},[2]);
 })();